export const fileExtension = function (url) {
  return (url = url.substr(1 + url.lastIndexOf("/")).split("?")[0])
    .split("#")[0]
    .substr(url.lastIndexOf("."));
};
